import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { store } from "./redux/storeConfig/store";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import Konva from "konva";

Konva.pixelRatio = 1;

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
serviceWorker.register();
